import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('checklist-section', []);

type ChecklistSectionController = angular.IStrictController;

module.component('checklistSection', {
    template: template,
    bindings: {
        sectionTitle: '<',
        description: '<'
    },
    controller: function(this: ChecklistSectionController) {
        this.$onInit = () => {};
    }
});

export { module };
